import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Col from 'react-bootstrap/Col'
import Pesos from '../components/Pesos'

export function HiddenInput({
  base,
  name,
  factor,
  minimo,
  fsp,
  tipoActividad,
  principalSuperaMinimo,
  year,
  cualquieraSuperaMinimo
}) {
  const { watch, register, setValue } = useFormContext()

  const value = watch(name)
  const b = watch(base)
  const crudo = parseFloat(b) * parseFloat(factor)

  useEffect(() => {
    let posible = true

    if (posible) {
      let v = crudo >= minimo ? crudo : minimo

      if (year === 2020) {
        if (tipoActividad === 'P') {
          v = crudo

          if (fsp && crudo < minimo) {
            v = minimo
          }
        }
      }

      if (tipoActividad === 'S') {
        if (principalSuperaMinimo) {
          v = crudo
        } else {
          v = 0
        }

        if (year === 2020) {
          v = crudo
        }
      }

      if (year === 2020 && crudo === 0) v = 0

      setValue(name, v || 0, { shouldValidate: true })
    }

    return () => {
      posible = false
    }
  }, [
    b,
    crudo,
    factor,
    name,
    setValue,
    minimo,
    tipoActividad,
    fsp,
    principalSuperaMinimo,
    year,
    cualquieraSuperaMinimo
  ])

  return (
    <>
      <input
        style={{ display: 'none' }}
        type="text"
        name={name}
        ref={register()}
      />

      <Col md={4}>
        <Pesos
          value={value}
          suffix={Number(value) === minimo ? ' (Monto mínimo)' : ''}
        />
      </Col>
    </>
  )
}

export function Sumatoria({ fspString, tasaString, name }) {
  const { watch, register, setValue } = useFormContext()

  const value = watch(name)
  const fsp = watch(fspString, 0)
  const tasa = watch(tasaString, 0)

  useEffect(() => {
    let posible = true

    if (posible) {
      const total = parseFloat(fsp) + parseFloat(tasa)
      setValue(name, total, { shouldValidate: true })
    }

    return () => {
      posible = false
    }
  }, [fsp, tasa, name, setValue])

  return (
    <>
      <input
        style={{ display: 'none' }}
        type="text"
        name={name}
        ref={register()}
        readOnly
      />
      <Col>
        <Pesos value={value} />
      </Col>
    </>
  )
}
